const Index = () => import("./index.vue");

export default [
  {
    path: "/data-export",
    component: Index,
  },
];
